import authGraphQLRequest from "utils/authGraphQLRequest";

export const getAllTabs = (type: string, params: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids, client_ids, time_frame, start_date, end_date, card_type } = params;

    let queryString = `{
  dashboardDetails(
    ${org_ids ? `org_ids: "${org_ids}",` : ""}
    ${client_ids ? `client_ids: "${client_ids}",` : ""}
    ${time_frame ? `time_frame: "${time_frame}",` : ""}
    ${start_date ? `start_date: "${start_date}",` : ""}
    ${end_date ? `end_date: "${end_date}",` : ""}
    ${card_type ? `card_type: "${card_type}",` : ""}
    is_live: "${type}"
  ) {
    totalTransactions
    transactionsApproved
    transactionsDeclined
    transactionsRefunded
    transactionsErrored
    transactionsFailed
  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_dashboard_details'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTransactionByGateway = (type: string, live: string, params: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids, client_ids, time_frame, start_date, end_date, card_type } = params;

    let apiURL = "";
    let queryString = "";

    if (type == 'approved') {

      apiURL = '/api/v1/graphql_dashboard_approved_details';

      queryString = `{
      gatewayPaymentApprovedDetails(
        ${time_frame ? `time_frame: "${time_frame}",` : ""}
        ${start_date ? `start_date: "${start_date}",` : ""}
        ${end_date ? `end_date: "${end_date}",` : ""}
        ${org_ids ? `org_ids: "${org_ids}",` : ""}
        ${client_ids ? `client_ids: "${client_ids}",` : ""}
        ${card_type ? `card_type: "${card_type}",` : ""}
        is_live: "${live}"
      )  {
        data
      }
    }
      `;
    }

    if (type == 'decline') {

      apiURL = '/api/v1/graphql_dashboard_decline_details';

      queryString = `{
        gatewayPaymentDeclineDetails(
          ${time_frame ? `time_frame: "${time_frame}",` : ""}
          ${start_date ? `start_date: "${start_date}",` : ""}
          ${end_date ? `end_date: "${end_date}",` : ""}
          ${org_ids ? `org_ids: "${org_ids}",` : ""}
          ${client_ids ? `client_ids: "${client_ids}",` : ""}
          ${card_type ? `card_type: "${card_type}",` : ""}
          is_live: "${live}"
        )  {
          data
        }
      }
    `;
    }

    if (type == 'errored') {

      apiURL = '/api/v1/graphql_dashboard_errored_details';

      queryString = `{
        gatewayPaymentErroredDetails(
          ${time_frame ? `time_frame: "${time_frame}",` : ""}
          ${start_date ? `start_date: "${start_date}",` : ""}
          ${end_date ? `end_date: "${end_date}",` : ""}
          ${org_ids ? `org_ids: "${org_ids}",` : ""}
          ${client_ids ? `client_ids: "${client_ids}",` : ""}
          ${card_type ? `card_type: "${card_type}",` : ""}
          is_live: "${live}"
        )  {
          data
        }
      }
    `;
    }

    if (type == 'failed') {

      apiURL = '/api/v1/graphql_dashboard_failed_details';

      queryString = `{
        gatewayPaymentFailedDetails(
          ${time_frame ? `time_frame: "${time_frame}",` : ""}
          ${start_date ? `start_date: "${start_date}",` : ""}
          ${end_date ? `end_date: "${end_date}",` : ""}
          ${org_ids ? `org_ids: "${org_ids}",` : ""}
          ${client_ids ? `client_ids: "${client_ids}",` : ""}
          ${card_type ? `card_type: "${card_type}",` : ""}
          is_live: "${live}"
        )  {
          data
        }
      }
    `;
    }


    authGraphQLRequest<any>(
      queryString,
      apiURL
    )
      .then((responseData) => {
        resolve(responseData);
        // resolve({});
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTransactionByAnalysis = (type: string, live: string, params: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids, client_ids, time_frame, start_date, end_date, card_type } = params;

    let queryString = `{
  transactionDetails(
    ${org_ids ? `org_ids: "${org_ids}",` : ""}
    ${client_ids ? `client_ids: "${client_ids}",` : ""}
    ${time_frame ? `time_frame: "${time_frame}",` : ""}
    ${start_date ? `start_date: "${start_date}",` : ""}
    ${end_date ? `end_date: "${end_date}",` : ""}
    ${card_type ? `card_type: "${card_type}",` : ""}
    is_live: "${live}"
  )  {
    Approved 
    Declined 
    Errored
    Failed
  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_dashboard_transaction_details'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTransactionByCurrency = (
  type: string,
  params: any,
  live: string
): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids, client_ids, time_frame, start_date, end_date, card_type } = params;

    let apiURL = "";
    let queryString = "";

    if (type == 'approved') {
      apiURL = '/api/v1/graphql_dashboard_approved_currency';
      queryString = `{
          paymentApprovedCurrencyDetails(
            ${org_ids ? `org_ids: "${org_ids}",` : ""}
            ${client_ids ? `client_ids: "${client_ids}",` : ""}
            ${time_frame ? `time_frame: "${time_frame}",` : ""}
            ${start_date ? `start_date: "${start_date}",` : ""}
            ${end_date ? `end_date: "${end_date}",` : ""}
            ${card_type ? `card_type: "${card_type}",` : ""}
            is_live: "${live}"
          )  {
            data
          }
        }
      `;
    }

    if (type == 'decline') {
      apiURL = '/api/v1/graphql_dashboard_decline_currency';
      queryString = `{
          paymentDeclineCurrencyDetails(
            ${org_ids ? `org_ids: "${org_ids}",` : ""}
            ${client_ids ? `client_ids: "${client_ids}",` : ""}
            ${time_frame ? `time_frame: "${time_frame}",` : ""}
            ${start_date ? `start_date: "${start_date}",` : ""}
            ${end_date ? `end_date: "${end_date}",` : ""}
            ${card_type ? `card_type: "${card_type}",` : ""}
            is_live: "${live}"
          )  {
            data
          }
        }
      `;
    }

    if (type == 'errored') {
      apiURL = '/api/v1/graphql_dashboard_errored_currency';
      queryString = `{
          paymentErroredCurrencyDetails(
            ${org_ids ? `org_ids: "${org_ids}",` : ""}
            ${client_ids ? `client_ids: "${client_ids}",` : ""}
            ${time_frame ? `time_frame: "${time_frame}",` : ""}
            ${start_date ? `start_date: "${start_date}",` : ""}
            ${end_date ? `end_date: "${end_date}",` : ""}
            ${card_type ? `card_type: "${card_type}",` : ""}
            is_live: "${live}"
          )  {
            data
          }
        }
      `;
    }

    if (type == 'failed') {
      apiURL = '/api/v1/graphql_dashboard_failed_currency';
      queryString = `{
          paymentFailedCurrencyDetails(
            ${org_ids ? `org_ids: "${org_ids}",` : ""}
            ${client_ids ? `client_ids: "${client_ids}",` : ""}
            ${time_frame ? `time_frame: "${time_frame}",` : ""}
            ${start_date ? `start_date: "${start_date}",` : ""}
            ${end_date ? `end_date: "${end_date}",` : ""}
            ${card_type ? `card_type: "${card_type}",` : ""}
            is_live: "${live}"
          )  {
            data
          }
        }
      `;
    }


    authGraphQLRequest<any>(
      queryString,
      apiURL
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getWawechratData = (params: any, type: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids, client_ids, time_frame, start_date, end_date, card_type } = params;

    let queryString = `{
  waveChartDetails(
    card_type : "${card_type}",
    client_ids : "${client_ids}",
    org_ids : "${org_ids}",
    ${time_frame ? `time_frame: "${time_frame}",` : ""}
    ${start_date ? `start_date: "${start_date}",` : ""}
    ${end_date ? `end_date: "${end_date}",` : ""}
    is_live: "${type}"
  ) {
    APPROVED 
    DECLINED 
    ERRORED 
    FAILED 
    grouped_by
    total_transactions
    transactions_approved
    transactions_declined
    transactions_errored
    transactions_failed
  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_dashboard_wave_details'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getOrganizationDetails = (): Promise<any> => {
  return new Promise((resolve, reject) => {
    let queryString = `{
  organizations {
    id
    name
    clients {
      id
      name
    }
  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_dashboard_Client_org'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getClientDetails = (params: any): Promise<any> => {
  return new Promise((resolve, reject) => {
    let { org_ids } = params;
    let queryString = `{
  clients(org_ids: "${org_ids}") {
    id
    name
  }
}
`;

    authGraphQLRequest<any>(
      queryString,
      '/api/v1/graphql_dashboard_Client'
    )
      .then((responseData) => {
        resolve(responseData);
      })
      .catch((err) => {
        reject(err);
      });
  });
};